module.exports = __webpack_public_path__ + "static/media/menu.584eca86.png";